import React, { useContext, createContext, useEffect, useState } from "react";
import useApi from "./use-api";

// const companyDefId = { sanchongzhiye: "22" };

const companyDefId = { 
  sanchong: "22", 
  "temp-staging-sanchong": "22"
};

const CompanyContext = createContext();
const useCompany = () => useContext(CompanyContext);

const useCompanyProvider = () => {
  const { getCompany } = useApi();
  const [eDepartmentId, setEDepartmentId] = useState(null);
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    if (!!eDepartmentId && eDepartmentId in companyDefId) {
      getCompany({
        eDepartmentId: companyDefId[eDepartmentId] /* eDepartmentId */,
        onSuccess: (result) => {
          setCompanyInfo(result);
        },
        onFail: () => {
          console.log("[Test] getCompany onFail ");
        },
      });
    }
  }, [eDepartmentId]);

  return {
    setEDepartmentId,
    companyInfo,
  };
};

const CompanyProvider = ({ children }) => {
  const shareProvider = useCompanyProvider();
  return (
    <CompanyContext.Provider value={shareProvider}>
      {children}
    </CompanyContext.Provider>
  );
};

export default useCompany;
export { CompanyProvider };
